import { useTranslation } from "react-i18next";
import { Modal, Spin } from "antd";

import "./WebGisCreatingModal.css";

interface Props {
  open: boolean;
  title?: string;
}

export const WebGisCreatingModal = ({ open, title }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      keyboard={false}
      mask={{ closable: false }}
      width={320}
      centered
      styles={{ container: { padding: "16px 20px" }, body: { padding: 0 } }}
    >
      <div className="webgis-creating-modal">
        <h3
          dangerouslySetInnerHTML={{ __html: title ?? t("webgis.isBeingCreatedPopup") }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: t("webgis.isBeingCreatedWaitPopup"),
          }}
        />
        <Spin size="large" />
      </div>
    </Modal>
  );
};
